import getLogos from './get-logos';
import Image from 'core/image';
import PropTypes from 'prop-types';
import styles from 'styles/Header.module.scss';
import { useOpenNav } from 'context/OpenNavContext';
import { useScroll } from 'hooks';
import useScrollTagID from 'hooks/useScrollToTagID';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

export const Logo = ({ disabledAnimation = false }) => {
    const [scrollLevel, setScrollLevel] = useState(0);
    const { openNav } = useOpenNav();
    const logos = getLogos();
    const t = useTranslations('header');
    const scrollToHome = useScrollTagID('home');

    useScroll((scroll) => {
        if (scroll <= 5) {
            setScrollLevel(0);
        } else if (scroll <= 10) {
            setScrollLevel(1);
        } else {
            setScrollLevel(2);
        }
    }, []);

    if (disabledAnimation) {
        return (
            <div>
                <Image
                    src={logos[0]}
                    width="150px"
                    height="40px"
                    layout="fixed"
                    alt={t('alt')}
                    priority={1}
                />
            </div>
        );
    }
    return (
        <div
            className={`${styles.sHeaderLogo} ${styles.transition} ${
                !(scrollLevel <= 1 || openNav) && styles.logoCompara
            }`}
            style={{ verticalAlign: 'bottom' }}
            onClick={scrollToHome}
        >
            <div
                style={{
                    paddingTop: '6.5px',
                    paddingLeft: '7.5px'
                }}
            >
                {scrollLevel <= 0 || openNav ?
                    (
                        <Image
                            src={logos[0]}
                            width="150px"
                            height="40px"
                            layout="fixed"
                            alt={t('alt')}
                            priority={1}
                        />
                    ) :
                    (
                        <Image
                            src={logos[1]}
                            width="32px"
                            height="34px"
                            alt={t('alt')}
                        />
                    )}
            </div>
        </div>
    );
};

Logo.propTypes = {
    disabledAnimation: PropTypes.bool
};
